var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('Details'),_c('p',{staticClass:"suggestions_feed_title"},[_vm._v("Plus de contenus similaires")]),_c('Feed',{staticClass:"suggestions_feed"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }